import { render, staticRenderFns } from "./mtxx-h5.vue?vue&type=template&id=cb228e80&scoped=true&"
import script from "./mtxx-h5.vue?vue&type=script&lang=js&"
export * from "./mtxx-h5.vue?vue&type=script&lang=js&"
import style0 from "./mtxx-h5.vue?vue&type=style&index=0&id=cb228e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb228e80",
  null
  
)

export default component.exports